<template>
  <section>
    <form>
      <div class="modal-card" style="width: 1080px">
        <header class="modal-card-head">
          <p class="modal-card-title">Datos de la afiliación</p>
          <button
              type="button"
              class="delete"
              @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Nombre Institución">
                <b-input v-model="related_institution.partner_entity_name" readonly></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Miembro en calidad de">
                <b-input v-model="related_institution.type_member" readonly></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Fecha de inicio">
                <b-input v-model="related_institution.start_date" readonly></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field label="Fecha de término">
                <b-input v-model="related_institution.end_date" readonly></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label=" ">

              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label=" ">

              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label=" ">

              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label=" ">

              </b-field>
            </div>
          </div>
          <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
        </section>
      </div>
      <footer class="modal-card-foot actions">
        <div class="has-text-right is-grouped">
          <button class="button" type="button" @click="$emit('close')">Cerrar</button>
          <b-button class="is-primary"
                    type="submit"
                    @click="editRelatedInstitution()">
            Editar Afiliación
          </b-button>
        </div>
      </footer>
      <b-modal
          v-model="isModalActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          width="1024"
          aria-role="dialog"
          aria-modal
          :can-cancel="false">
        <template #default="props">
          <modal_new_related_institution
              :person-id="personId"
              :update="update"
              :old_related_institution="old_related_institution"
              @close="props.close" 
              @refresh="$emit('refresh')" />
        </template>
      </b-modal>
    </form>
  </section>
</template>

<script>

import modal_new_related_institution from "./modal_new_related_institution";
import axios from "axios";
import moment from "moment";
export default {
  name: "modal_show_related_institution",
  components:{modal_new_related_institution},
  props:['personId','old_related_institution'],
  data(){
    return{
      update: false,
      isModalActive: false,
      isLoading: false,
      related_institution: {}
    }
  },
  async created() {
    await this.initialize()
  },
  methods:{
    async initialize(){
      this.update = false
      this.isLoading = true
      await axios
          .get('/related_institutions/'+this.old_related_institution.id+'.json')
          .then(response=>{
            this.related_institution = response.data
            this.related_institution.start_date = moment(this.related_institution.start_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
            this.related_institution.start_date = new Date(this.related_institution.start_date).toLocaleDateString("es-CL")
            if(this.related_institution.end_date != null){
              this.related_institution.end_date = moment(this.related_institution.end_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
              this.related_institution.end_date = new Date(this.related_institution.end_date).toLocaleDateString("es-CL")
            }
            else{
              this.related_institution.end_date = ''
            }
          })
          .catch(error => {
            this.$buefy.dialog.alert({
              title: 'Error',
              message: 'Hubo un error al obtener los datos. Intente más tarde',
              type: 'is-danger',
              hasIcon: true,
              icon: 'times-circle',
              iconPack: 'fa',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
            this.$emit('close')
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    editRelatedInstitution(){
      this.update = true
      this.isModalActive = true
    }
  },
  watch: {
    isModalActive: async function () {
      if (!this.isModalActive) {
        await this.initialize()
      }
    },
  }
}
</script>

<style scoped>

</style>